import { ContentType } from '@bm-js/atlascloud-shared'

export type DndState = {
  currentDraggingContent?: ContentType<unknown>
}

export const initialDndState: DndState = {}
